import { useMemo } from 'react';
import { generatePath } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';

import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';

const useTicketOwnerUpdate = ({ ticketId }: { ticketId?: number }) => {
  const endpoint = useMemo(
    () =>
      generatePath(apiPaths.FOLLOW_UP.TICKETS.CHANGE_OWNER, {
        id: ticketId ?? 'placeholder-that-will-never-be-used',
      }),
    [ticketId],
  );

  return useMutation<any, any, { ownerId?: number }>({
    mutationKey: [endpoint],
    mutationFn: ({ ownerId }) =>
      HttpService.put(endpoint, { ownerId })
        .then((data) => Promise.resolve(data.data))
        .catch(({ response }) => Promise.reject(response.status)),
    onError: (error) => error,
  });
};

export default useTicketOwnerUpdate;
